import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageShares,
  PageShare,
} from '../pages/shares';

const RouteShares = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageShares />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageShare />
      </Route>
    </Switch>
  );
};

export default RouteShares;
